// extracted by mini-css-extract-plugin
module.exports = {"nav":"BreadcrumbsBase_nav__npjAu"};